import { Component, OnInit } from '@angular/core';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: 'confirm-dialog.component.html',
    styleUrls: ['confirm-dialog.component.scss'],
    standalone: false
})

export class ConfirmDialogComponent implements OnInit {
    message: any;
    message_withclose:any;
    isLoaded:boolean = false;
    confirmationInput: string = '';
    constructor(
        private confirmDialogService: ConfirmDialogService
    ) { }

    ngOnInit(): any {
       /**
        *   This function waits for a message from alert service, it gets
        *   triggered when we call this from any other component
        */
        setTimeout(()=>{this.isLoaded=true;},350);
        this.confirmDialogService.getMessage().subscribe(message => {
            this.message = message;
            this.resetConfirmationInput();
        });
        this.confirmDialogService.getMessage_withclose().subscribe(message_withclose => {
            this.message_withclose = message_withclose;
            this.resetConfirmationInput();
        });
    }
    onYesClick(): void {
      if (
        this.message_withclose?.confirmationTextRequired &&
        this.confirmationInput !== (this.message_withclose.requiredText || 'DELETE')
      ) {
        return; // Prevent action if the button should be disabled
      }
        if (this.message) {
          this.message.yesFn();
        } else if (this.message_withclose) {
          this.message_withclose.yesFn();
        }
        this.resetConfirmationInput();
      }
    
      onNoClick(): void {
        if (this.message) {
          this.message.noFn();
        } else if (this.message_withclose) {
          this.message_withclose.noFn();
        }
        this.resetConfirmationInput();
      }
    
      private resetConfirmationInput(): void {
        this.confirmationInput = '';
      }
}
